const e = {
  "sans-serif": {
    xs: {
      fontSize: "xs",
      lineHeight: "xs",
      letterSpacing: "xs"
    },
    sm: {
      fontSize: "sm",
      lineHeight: "sm",
      letterSpacing: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: "md",
      letterSpacing: "md"
    },
    lg: {
      fontSize: "lg",
      lineHeight: "lg",
      letterSpacing: "lg"
    },
    xl: {
      fontSize: "xl",
      lineHeight: "xl",
      letterSpacing: "xl"
    },
    "2xl": {
      fontSize: "2xl",
      lineHeight: "2xl",
      letterSpacing: "2xl"
    },
    "3xl": {
      fontSize: "3xl",
      lineHeight: "3xl",
      letterSpacing: "3xl"
    },
    "4xl": {
      fontSize: "4xl",
      lineHeight: "4xl",
      letterSpacing: "4xl"
    },
    "5xl": {
      fontSize: "5xl",
      lineHeight: "5xl",
      letterSpacing: "5xl"
    },
    "6xl": {
      fontSize: "6xl",
      lineHeight: "6xl",
      letterSpacing: "6xl"
    },
    h6: {
      fontSize: "h6",
      lineHeight: "h6",
      letterSpacing: "h6"
    },
    h5: {
      fontSize: "h5",
      lineHeight: "h5",
      letterSpacing: "h5"
    },
    h4: {
      fontSize: "h4",
      lineHeight: "h4",
      letterSpacing: "h4"
    },
    h3: {
      fontSize: "h3",
      lineHeight: "h3",
      letterSpacing: "h3"
    },
    h2: {
      fontSize: "h2",
      lineHeight: "h2",
      letterSpacing: "h2"
    },
    h1: {
      fontSize: "h1",
      lineHeight: "h1",
      letterSpacing: "h1"
    },
    hero2: {
      fontSize: "hero2",
      lineHeight: "hero2",
      letterSpacing: "hero2"
    },
    hero1: {
      fontSize: "hero1",
      lineHeight: "hero1",
      letterSpacing: "hero1"
    }
  },
  serif: {
    xl: {
      fontSize: "xl",
      lineHeight: "xl",
      letterSpacing: "xl"
    },
    "2xl": {
      fontSize: "2xl",
      lineHeight: "2xl",
      letterSpacing: "2xl"
    },
    "3xl": {
      fontSize: "3xl",
      lineHeight: "3xl",
      letterSpacing: "3xl"
    },
    "4xl": {
      fontSize: "4xl",
      lineHeight: "4xl",
      letterSpacing: "4xl"
    },
    "5xl": {
      fontSize: "5xl",
      lineHeight: "5xl",
      letterSpacing: "5xl"
    },
    "6xl": {
      fontSize: "6xl",
      lineHeight: "6xl",
      letterSpacing: "6xl"
    },
    h6: {
      fontSize: "h6",
      lineHeight: "h6",
      letterSpacing: "h6"
    },
    h5: {
      fontSize: "h5",
      lineHeight: "h5",
      letterSpacing: "h5"
    },
    h4: {
      fontSize: "h4",
      lineHeight: "h4",
      letterSpacing: "h4"
    },
    h3: {
      fontSize: "h3",
      lineHeight: "h3",
      letterSpacing: "h3"
    },
    h2: {
      fontSize: "h2",
      lineHeight: "h2",
      letterSpacing: "h2"
    },
    h1: {
      fontSize: "h1",
      lineHeight: "h1",
      letterSpacing: "h1"
    },
    hero2: {
      fontSize: "hero2",
      lineHeight: "hero2",
      letterSpacing: "hero2"
    },
    hero1: {
      fontSize: "hero1",
      lineHeight: "hero1",
      letterSpacing: "hero1"
    }
  }
};
export {
  e as typographySemanticTokens
};
